<script lang="ts">
  import { useCoreStore } from '@/ui/state/use-core-state.svelte';

  import { useAuthState } from '../use-auth.svelte';
  import LoginFooter from './cmps/LoginFooter.svelte';
  import LoginDialog from './LoginDialog.svelte';

  let authState = useAuthState();
  let auth = $derived(authState.current);
  let CS = useCoreStore();
</script>

{#if !auth.loggedIn || !$CS.initialized}
  <div class="flex h-full flex-col">
    <main
      class="flex h-full flex-1 items-center justify-center rounded-lg bg-gradient-to-b from-login-start to-login-end shadow-login"
    >
      <LoginDialog />
    </main>

    <LoginFooter></LoginFooter>
  </div>
{/if}
